import { Component, inject, ChangeDetectionStrategy} from '@angular/core';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { ErrorStateComponent } from '../error-state/error-state.component';

@Component({
    selector: 'gcp-workspace-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrl: './access-denied.component.scss',
    imports: [ErrorStateComponent, MatButton],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessDeniedComponent {
  private readonly router = inject(Router);

  goToHome() {
    void this.router.navigate(['/home']);
  }
}
